import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import IconButton from "@mui/material/IconButton";
import type { Attachment } from "../../../../FeedbackDialog.types";

type FeedbackDialogAttachmentPreviewProps = {
  attachment: Attachment;
  onRemove: () => void;
};

const FeedbackDialogAttachmentPreview = ({
  attachment,
  onRemove,
}: FeedbackDialogAttachmentPreviewProps) => (
  <div className="group relative w-fit">
    <img
      src={attachment.src}
      alt={attachment.name ?? "Attachment preview"}
      className="h-24 rounded border border-divider object-cover"
    />
    <IconButton
      type="button"
      size="small"
      aria-label="Remove attachment"
      onClick={onRemove}
      className="absolute top-1 right-1 bg-background-paper opacity-0 transition-opacity group-hover:opacity-100 shadow-md"
    >
      <CloseOutlinedIcon fontSize="small" />
    </IconButton>
  </div>
);

export default FeedbackDialogAttachmentPreview;
